import { captureAcquisition } from 'lib/acquisition';

// First-touch attribution — runs once at module load, before React renders.
// Router redirects (RequireAuth -> /login, the catch-all) run in effects and
// replace the URL, so capturing from a component effect would read a URL that
// has already lost its UTM query. captureAcquisition never throws.
captureAcquisition();

export {};
